import { Component, OnDestroy } from '@angular/core';
import { BaseDestroyable } from '@core/base-destroyable';
import { TlkSlideToggleComponent, TlkSlideToggleEvent } from '@itero/ui-toolkit-angular/slide-toggle';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CommonModule } from '@nodeModules/@angular/common';
import { ShowAllService } from './show-all.service';
import { SharedDirectivesModule } from '@shared/directives/shared-directives.module';

@Component({
	selector: 'show-all-toggle',
	standalone: true,
	imports: [CommonModule, TranslateModule, TlkSlideToggleComponent, SharedDirectivesModule],
	templateUrl: './show-all-toggle.component.html',
	styleUrl: './show-all-toggle.component.scss',
})
export class ShowAllToggleComponent extends BaseDestroyable implements OnDestroy {
	private readonly showAllKey: string = 'FOV.ShowFromAllDoctors';
	showAllTranslation$: Observable<string> = this.translateService.get(this.showAllKey);
	isShowAllSwoEnabled$: Observable<boolean> = this.showAllService.isShowAllSwoEnabled$;
  isShowAllToggleEnabled$ = this.showAllService.isShowAllToggleEnabled$;


	constructor(private readonly showAllService: ShowAllService, private readonly translateService: TranslateService) {
		super();
	}

	valueChanges(event: TlkSlideToggleEvent) {
		const { checked } = event;
		this.showAllService.updateIsShowAllToggleEnabled(checked);
	}

	override ngOnDestroy() {
		super.ngOnDestroy();
		this.showAllService.updateIsShowAllToggleEnabled(false);
		this.showAllService.resetState();
	}
}
